import { Theme } from '@mui/material';
/**
 * Styling for ccfImageWithZoomStyles
 * @returns ccfImageWithZoomStyles CSS properties as a JSON object
 * @example ccfImageWithZoomStylesStyles(theme)
*/
const ccfImageWithZoomStyles = (theme: Theme) => {
  const styles = {
    widthInputCollapsed:{
      width: 'calc(100% - 7.5rem)',
      height: 'calc(100% - 3.5rem)',
    },
    widthBelowMd:{
      width: 'calc(100% - 3.5rem)',
      height: '25rem',
    },
    expandedDialog : {         
      position: 'fixed',
      top: 'auto',
      right: '0',
      bottom: '0',                
      left: 'auto',                 
      overflowY:'auto' ,
      backgroundColor: 'rgba(0, 0, 0, 0.88)',
      width : 'calc(100% - 18.313rem)',
      height : 'calc(100% - 3.5rem)',

      [theme.breakpoints.down('md')]: {
        top: '6.75rem',
        left: '3.5rem',
      },
      
      '& .MuiPaper-root':{
        maxWidth: 'none',
        width: '100%',
        height: '100%',
        boxShadow: 'none',
        background: 'none',
      },

      '& .MuiBackdrop-root': {
        left: 'auto',
        top: 'auto',
      },
    },
    closeDialog: {
      marginLeft: 'auto',
      color: theme?.palette?.text?.white,
    },
    dialogImage: {
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'center',
    },
    dialogActions:{
      justifyContent: 'center',
    },
    dialogButtons:{
      border:`0.063rem solid ${theme?.palette?.background?.zoomIconsBackground}`,
      background: theme.palette.text.white,
    },
    zoomOutButton:{
      paddingTop: '0.5rem',
      color: theme?.palette?.background?.zoomIconsBackground,
    },
    zoomInButton:{
      color: theme?.palette?.background?.zoomIconsBackground,
    },
  }
  return styles
}

export default ccfImageWithZoomStyles